import * as process from "process";
import { brand } from "@/config/brand";

export type ENVIRONMENTS = "development" | "production" | "staging" | string;

// В проде значения приходят из CI (build-arg). Иначе берём дефолт бренда,
// чтобы сборка по одному NEXT_PUBLIC_BRAND работала и без остальных переменных.
export const NEXT_PUBLIC_DOMAIN: string = process.env.NEXT_PUBLIC_DOMAIN || brand.domain;
export const NEXT_PUBLIC_BASE_URL: string = process.env.NEXT_PUBLIC_BASE_URL || brand.baseUrl;
// Активный бренд. Фолбэк — brand.id (его кодоген уже разрешил из NEXT_PUBLIC_BRAND).
export const NEXT_PUBLIC_BRAND: string = process.env.NEXT_PUBLIC_BRAND || brand.id;

export const VERSION: string =
    process.env.NEXT_PUBLIC_VERSION || process.env.VERSION || "local";
export const NODE_ENV: ENVIRONMENTS = process.env.NODE_ENV;

// Hack. NextJS supports NODE_ENV only development, production, test
export const ENVIRONMENT: ENVIRONMENTS =
    process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NODE_ENV;

console.info(brand.copy.consoleLabel);
console.info("  ↳  Version: " + VERSION);
console.info("  ↳  Environment: " + ENVIRONMENT);

const css = `color: #EC4848FF; font-size: 24px;`;
console.log(
  "%c Внимание! Не вставляйте в консоль никакой код, если вы не уверены, что он делает. Это может привести к взлому аккаунта",
  css
);
